<template>
  <div class="header">
    <div class="title">
      “开放北京”公共信息服务平台（二期）
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  created () {
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/base.scss";

.header {
  width: 100%;
  min-width: 1200px;
  height: 100px;
  background-color: #bd1a2d;
  color: white;
  font-size: 36px;
  font-weight: bold;
  line-height: 100px;

  .title {
    margin-left: 50px;
    font-size: 32px;
  }
}
</style>
